/**
 * Labstep
 *
 * @module constants/filters
 * @desc Filters
 */

export enum Filter {
  created_by = 'created_by',
  log_created_by = 'log_created_by',
  assigned_to = 'assigned_to',
  deleted = 'deleted',
  signed = 'signed',
  date_range = 'date_range',
  user_search_select = 'user_search_select',
  tag = 'tag',
  resource_item_status = 'resource_item_status',
  available_resource_item_count = 'available_resource_item_count',
  order_request_status = 'order_request_status',
  purchase_order_status = 'purchase_order_status',
  extension = 'extension',
  protocol = 'protocol',
  resource = 'resource',
  device = 'device',
  is_user_deleted = 'is_user_deleted',
  experiment_workflow_status = 'experiment_workflow_status',
  experiment_workflow_status_type = 'experiment_workflow_status_type',
  resource_location = 'resource_location',
  requested_by = 'requested_by',
  molecule = 'molecule',
  metadata = 'metadata',
  resource_metadata = 'resource_metadata',
  is_group_deleted = 'is_group_deleted',
  entity_state_name = 'entity_state_name',
  protocol_collection_status = 'protocol_collection_status',
  group = 'group',
  log_object_class = 'log_object_class',
  metadata_experiment_workflow = 'metadata_experiment_workflow',
}
